import cn from "classnames";
import { FC } from "react";
import Modal from "../Modal";
import ModalContent from "../Modal/ModalContent";
import styles from "./Wallet.module.scss";

interface Props {
    isVisible: boolean;
    setIsVisible: (isVisible: boolean) => void;
    setIsImportModalVisible: (isVisible: boolean) => void;
    setIsCreateModalVisible: (isVisible: boolean) => void;
}

const ConnectProfile: FC<Props> = ({ isVisible, setIsVisible, setIsImportModalVisible, setIsCreateModalVisible }) => {
    return (
        <Modal isVisible={isVisible} setIsVisible={setIsVisible}>
            <ModalContent classNames={styles.content}>
                <div className={styles.header}>
                    <h2 className={styles.headline}>Connect wallet</h2>
                    <button className={styles.close} onClick={() => setIsVisible(false)}>
                        <picture>
                            <source
                                srcSet="/images/modal/closemobile.svg"
                                width={7.5}
                                height={7.5}
                                media="(max-width: 768px)"
                            />
                            <img
                                height={12}
                                width={12}
                                src="/images/modal/close.svg"
                                style={{ opacity: 0.4 }}
                                alt="Close modal"
                            />
                        </picture>
                    </button>
                </div>
                <p className={styles.description}>
                    To use the sniper and fast transactions, you need to create a new wallet. To use swap, you can use
                    your wallet
                </p>
                <a className={styles.link} href="/">
                    <span>Learn more</span>
                    <img width={8} height={8} src="/images/modal/learnarrow.svg" alt="" />
                </a>
                <div className={styles.buttons}>
                    <button onClick={() => setIsCreateModalVisible(true)} className={styles.button}>
                        <div className={styles.text}>
                            <div className={styles.wallet}>Create new wallet</div>
                        </div>
                        <div className={cn(styles.img, styles.nest)}>
                            <img height={22} width={22} src="/images/modal/nest.svg" alt="" />
                        </div>
                    </button>
                    <button onClick={() => setIsImportModalVisible(true)} className={styles.button}>
                        <div className={styles.text}>
                            <div className={styles.wallet}>Import your wallet</div>
                        </div>
                        <div className={cn(styles.img, styles.nest)}>
                            <img height={22} width={22} src="/images/modal/key.svg" alt="" />
                        </div>
                    </button>
                </div>
            </ModalContent>
        </Modal>
    );
};

export default ConnectProfile;
